<div class="main-card mb-3 card">
  <div class="card-body">
    <div class="title-block mb-3">
      <i class="fa fa-fw" [title]="'TR_GOBACK' | translate" (click)="mainService.goBack('paymentpackage')"></i>
      <h5 class="card-title">{{ isCreateForm ? ('TR_CREATE_PAYMENT_PACKAGE' | translate) : ('TR_UPDATE_PAYMENT_PACKAGE' | translate) }}</h5> 
    </div>
    <form (submit)="submitData()" [formGroup]="form">
      <div class="form-row">
        <div class="col-lg-4 col-md-4">
          <div class="position-relative form-group">
            <label for="packageName">{{ ('TR_NAME' | translate) + mainService.asterisk }}</label>
            <input
              name="packageName"
              [placeholder]="('TR_NAME' | translate) + mainService.asterisk"
              type="text"
              class="form-control"
              [class.error-border]="isInvalidSubmit && !form.value.packageName"
              autocomplete="off"
              formControlName="packageName"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4 col-md-4">
          <div class="position-relative form-group">
            <label for="description">{{ 'TR_DESCRIPTION' | translate }}</label>
            <input
              name="description"
              [placeholder]="'TR_DESCRIPTION' | translate"
              type="text"
              class="form-control"
              autocomplete="off"
              formControlName="description"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4 col-md-4">
          <div class="position-relative form-group">
            <label for="cost">{{('TR_COST' | translate) + mainService.asterisk}}</label>
            <input
              name="cost"
              [placeholder]="('TR_COST' | translate) + mainService.asterisk"
              type="number"
              class="form-control"
              [class.error-border]="isInvalidSubmit && !form.value.cost"
              autocomplete="off"
              formControlName="cost"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4 col-md-4">
          <div class="position-relative form-group">
            <label for="storageSize">{{ ('TR_STORAGE_SIZE' | translate) + mainService.asterisk}}</label>
            <input
              name="storageSize"
              [placeholder]="'TR_STORAGE_SIZE' | translate"
              type="number"
              class="form-control"
              autocomplete="off"
              formControlName="storageSize"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4 col-md-4">
          <div class="position-relative form-group">
            <label for="webinarStudentsMaxCount">{{ ('TR_WEBINAR_STUDENTS_MAX_COUNT' | translate) + mainService.asterisk }}</label>
            <input
              name="webinarStudentsMaxCount"
              [placeholder]="'TR_WEBINAR_STUDENTS_MAX_COUNT' | translate"
              type="number"
              class="form-control"
              autocomplete="off"
              formControlName="webinarStudentsMaxCount"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4 col-md-4">
          <div class="position-relative form-group">
            <label for="userMaxCount">{{ ('TR_ORGANIZATION_USERS_MAX_COUNT' | translate) + mainService.asterisk }}</label>
            <input
              name="userMaxCount"
              [placeholder]="'TR_ORGANIZATION_USERS_MAX_COUNT' | translate"
              type="number"
              class="form-control"
              autocomplete="off"
              formControlName="userMaxCount"
            />
          </div>
        </div>
      </div>
      <div class="position-relative form-check">
        <input name="allowSaveVideo" id="allowSaveVideo" type="checkbox" class="form-check-input" formControlName="allowSaveVideo">
        <label for="allowSaveVideo" class="form-check-label">{{ 'TR_ALLOW_VIDEO_SAVE' | translate }}</label>
      </div>
      <app-submit-button
        [spinnerId]="submitSpinnerId"
        [buttonName]="isCreateForm ? ('TR_CREATE' | translate) : ('TR_UPDATE' | translate)"
        [isInvalidSubmit]="isInvalidSubmit"
        [isFormValid]="form.valid"
      ></app-submit-button>
    </form>
  </div>
</div>